<script setup lang="ts">
import type { AgentContactBarSectionProps } from '.';

import { useAgentProfileStore } from '~/store/agentProfileStore';
import { storeToRefs } from 'pinia';

import { AgentContactBar } from '~/components/AgentContactBar';

const props = defineProps<AgentContactBarSectionProps>();

const emit = defineEmits<{
	(e: 'contactClick'): void;
}>();

// Mesma fonte única do card: a store da página.
const { profile } = storeToRefs(useAgentProfileStore());

const agentPictureSrc = computed(
	() =>
		profile.value?.profilePicture?.croppedUrl ||
		profile.value?.profilePicture?.url ||
		''
);
</script>

<template>
	<AgentContactBar
		v-if="profile"
		:class="props.class"
		:agent-name="profile.name"
		:agent-picture-src="agentPictureSrc"
		:company-name="profile.company?.name"
		:company-logo-src="profile.company?.smallLogo"
		@contact-click="emit('contactClick')"
	/>
</template>
